<template>
    <div class="history mg-sm-15 mt-4">
        <div class="title mg-sm-15">入札履歴 ({{histories.length}}件)</div>

        <div class="" v-for="history in histories">
            <div class="item-history">
                <div class="left-history">
                    <button class="tag tag-black" style="background: #E52D51" v-if="history.type == 6">LIVE</button>
                    <button class="tag tag-pink" style="background: #55B08C" v-if="history.type == 2">ROOM</button>
                    <button class="tag tag-brown" style="background: #68A1C5" v-if="history.type == 3">事前入札</button>
                </div>
                <div class="right-history">
                    <div class="top"><strong v-if="history.member_id == member.id">あなたの入札</strong> ¥ {{ formatPrice(history.amount) }}</div>
                    <div class="bottom">{{ history.formatted_created_at }}<span>{{ showDuplicateBidAmountMax() }}</span></div>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
.item-history .tag{
    padding: 7px !important;
    width: 80px !important;
}
</style>
<script>
    export default {
        mounted() {
        },
        async created() {
            this._duplicateAmount = this.duplicateBidAmountMax;
        },
        watch: {
            duplicateBidAmountMax(newValue) {
                this._duplicateAmount = newValue;
                this.duplicateAmount = this._duplicateAmount;
            }
        },
        data: function () {
            return {
                duplicateAmount: this.duplicateBidAmountMax,
            }
        },
        props: ['histories', 'member', 'duplicateBidAmountMax'],
        methods: {
            formatPrice(price) {
                return price.toLocaleString(undefined, {maximumFractionDigits: 0});
            },
            showDuplicateBidAmountMax() {
                if(this.duplicateAmount > 1 && this._duplicateAmount > 0) {
                    return ' (' + this._duplicateAmount -- + '位)';
                }

                return '';
            }
        },
    }
</script>
